/* capkov-rd: live thread colour preview (colour change) + recoloured thumbnail in the cart / set editor.   [r2, 6. 10.]
   Photos of ready-made caps carry the embroidery inside the photo (no separate transparent layer), so the thread is found
   in the photo itself and recoloured on a canvas with the stitch shading kept.
   r2: one analysis per photo (cached), run in a Worker; a colour change only re-tints the cached mask (a few ms).
       - light thread on a dark/coloured cap and dark thread on a light cap (polarity is detected),
       - hysteresis mask: thin lines, dots, small blobs (antenna tips) and anti-aliased edges are included,
       - proportional edge unmixing (no white halo), luminance of the stitches preserved,
       - the crop follows the embroidery bounding box + padding (never cut).
   The builder, prices and line item properties are NOT changed, we only read the selected colour from its buttons.
   Interface: window.RdThread.mount(canvas, imgUrl, hex, crop) -> Promise({ok, reason});  .paintSync();  .overlay(); .prefetch(). */
(function () {
  'use strict';
  if (window.RdThread) return;
  var FW = 640, OW = 640, OH = 320, MAXC = 10;
  var DEF_CROP = { x: 0.5, y: 0.46, w: 0.8 };

  /* ================= analysis core: pure function over pixels, runs in a Worker (no DOM) ================= */
  function RDCORE() {
    function med(a) { if (!a.length) return 0; a = Array.prototype.slice.call(a).sort(function (p, q) { return p - q; }); return a[a.length >> 1]; }
    function pct(a, q) { if (!a.length) return 0; a = Array.prototype.slice.call(a).sort(function (p, r) { return p - r; }); return a[Math.min(a.length - 1, Math.floor(a.length * q))]; }
    function blur(src, w, h, r) {   /* box blur, replicated edges, O(n), padded line buffers (no per-sample clamping) */
      var tmp = new Float32Array(w * h), out = new Float32Array(w * h), x, y, s, k, m = Math.max(w, h) + 2 * r + 2, pad = new Float32Array(m), n2 = (2 * r + 1) * (2 * r + 1), inv = 1 / n2, L = 2 * r + 1;
      for (y = 0; y < h; y++) {
        var o = y * w, v0 = src[o], v1 = src[o + w - 1];
        for (k = 0; k < r; k++) pad[k] = v0;
        for (x = 0; x < w; x++) pad[r + x] = src[o + x];
        for (k = 0; k < r; k++) pad[r + w + k] = v1;
        s = 0; for (k = 0; k < L; k++) s += pad[k];
        for (x = 0; x < w; x++) { tmp[o + x] = s; s += pad[x + L] - pad[x]; }
      }
      for (x = 0; x < w; x++) {
        var t0 = tmp[x], t1 = tmp[(h - 1) * w + x];
        for (k = 0; k < r; k++) pad[k] = t0;
        for (y = 0; y < h; y++) pad[r + y] = tmp[y * w + x];
        for (k = 0; k < r; k++) pad[r + h + k] = t1;
        s = 0; for (k = 0; k < L; k++) s += pad[k];
        for (y = 0; y < h; y++) { out[y * w + x] = s * inv; s += pad[y + L] - pad[y]; }
      }
      return out;
    }
    function ds(src, w, h) {   /* 2x2 average */
      var w2 = w >> 1, h2 = h >> 1, o = new Float32Array(w2 * h2), x, y, i;
      for (y = 0; y < h2; y++) for (x = 0; x < w2; x++) { i = 2 * y * w + 2 * x; o[y * w2 + x] = (src[i] + src[i + 1] + src[i + w] + src[i + w + 1]) * 0.25; }
      return o;
    }
    function dil(B, w, h, r) {
      var f = new Float32Array(w * h), i, o = new Uint8Array(w * h);
      for (i = 0; i < f.length; i++) f[i] = B[i] ? 1 : 0;
      var b = blur(f, w, h, r); for (i = 0; i < o.length; i++) o[i] = b[i] > 0.0001 ? 1 : 0; return o;
    }
    function nblur(ch, wgt, w, h, r) {   /* normalised convolution: local average of ch over weight wgt, null where no support */
      var n = w * h, i, num = new Float32Array(n);
      for (i = 0; i < n; i++) num[i] = ch[i] * wgt[i];
      var bn = blur(num, w, h, r), bw = blur(wgt, w, h, r), out = new Float32Array(n);
      for (i = 0; i < n; i++) out[i] = bw[i] > 0.04 ? bn[i] / bw[i] : -1;
      return out;
    }
    function label(D, B, w, h) {   /* 8-connected components of D, counting B pixels, bbox of B pixels */
      var n = w * h, lab = new Int32Array(n), L = 0, cnt = [0], bb = [null], st = new Int32Array(n), sp, i, q, x, y, dx, dy, xx, yy, nb, b;
      for (i = 0; i < n; i++) {
        if (!D[i] || lab[i]) continue;
        L++; cnt[L] = 0; bb[L] = [w, h, -1, -1]; lab[i] = L; sp = 0; st[sp++] = i;
        while (sp) {
          q = st[--sp]; x = q % w; y = (q / w) | 0;
          if (B[q]) { cnt[L]++; b = bb[L]; if (x < b[0]) b[0] = x; if (y < b[1]) b[1] = y; if (x > b[2]) b[2] = x; if (y > b[3]) b[3] = y; }
          for (dy = -1; dy <= 1; dy++) for (dx = -1; dx <= 1; dx++) {
            if (!dx && !dy) continue; xx = x + dx; yy = y + dy; if (xx < 0 || yy < 0 || xx >= w || yy >= h) continue;
            nb = yy * w + xx; if (D[nb] && !lab[nb]) { lab[nb] = L; st[sp++] = nb; }
          }
        }
      }
      return { lab: lab, L: L, cnt: cnt, bb: bb };
    }
    var EMPTY = function (why, st) { return { ok: false, reason: why, st: st || null }; };

    /* one polarity: pol 'l' = light thread (white-ish) on darker / more saturated fabric, 'd' = dark thread on light fabric */
    function detect(px, W, H, knit, pol, X) {
      var n = W * H, i, x, y, F = X.F[pol], Sat = X.Sat, inner = X.inner, vals = [], medF, medS;
      for (y = (H * 0.25) | 0; y < H * 0.75; y += 2) for (x = (W * 0.25) | 0; x < W * 0.75; x += 2) vals.push(F[y * W + x]);
      medF = med(vals);
      if (medF > 215) return EMPTY(pol === 'l' ? 'light' : 'darkfabric');
      var chv = []; for (y = (H * 0.25) | 0; y < H * 0.75; y += 3) for (x = (W * 0.25) | 0; x < W * 0.75; x += 3) chv.push(Sat[y * W + x]);
      medS = med(chv);
      /* light thread is nearly neutral: on a coloured fabric (HSV saturation in %) the light but coloured spots of the fabric do not count */
      var satMax = (pol === 'l' && medS > 14) ? Math.max(12, medS * 0.62) : 999;
      var mask = new Uint8Array(n), thr0 = medF + 60, it, diff = new Float32Array(n), thr = 40, peak = 0, bg = new Float32Array(n), wgt = new Float32Array(n), dm, dv;
      for (i = 0; i < n; i++) mask[i] = (inner[i] && F[i] > thr0 && Sat[i] <= satMax) ? 1 : 0;
      for (it = 0; it < 3; it++) {
        dm = dil(mask, W, H, 5);
        for (i = 0; i < n; i++) wgt[i] = (dm[i] || !inner[i]) ? 0 : 1;
        var W2 = W >> 1, H2 = H >> 1, F2 = ds(F, W, H), w2 = ds(wgt, W, H), a1 = nblur(F2, w2, W2, H2, 11), a2 = null, allb = null, miss = 0, xx2, yy2;
        for (i = 0; i < a1.length; i++) if (a1[i] < 0) { miss = 1; break; }
        if (miss) { a2 = nblur(F2, w2, W2, H2, 35); allb = blur(F2, W2, H2, 35); }   /* big solid areas (head of the bee): fabric from the wider surroundings */
        for (y = 0; y < H; y++) for (x = 0; x < W; x++) {
          xx2 = Math.min(W2 - 1, x >> 1); yy2 = Math.min(H2 - 1, y >> 1); k = yy2 * W2 + xx2;
          bg[y * W + x] = a1[k] >= 0 ? a1[k] : (a2[k] >= 0 ? a2[k] : allb[k]);
        }
        dv = [];
        for (i = 0; i < n; i++) { diff[i] = (inner[i] && Sat[i] <= satMax) ? F[i] - bg[i] : 0; if (diff[i] > 8 && !(i & 1)) dv.push(diff[i]); }
        peak = dv.length ? pct(dv, 0.985) : 0;
        thr = Math.max(32, Math.min(70, peak * 0.42));
        for (i = 0; i < n; i++) mask[i] = diff[i] > thr ? 1 : 0;
      }
      /* absolute level: thread is the lightest (darkest for dark thread) thing on the cap; softly lighter washed patches of the fabric are clearly below it */
      var sF = []; for (i = 0; i < n; i++) if (mask[i]) sF.push(F[i]);
      if (sF.length) { var fTop = pct(sF, 0.995), fMin = fTop * 0.66; for (i = 0; i < n; i++) if (mask[i] && F[i] < fMin) mask[i] = 0; }
      /* strong pixels must be about as bright as the thread itself: dim fleck / seam pixels hanging on the design are dropped (anti-aliased edges stay: within 2 px of a bright pixel) */
      var sd = []; for (i = 0; i < n; i++) if (mask[i]) sd.push(diff[i]);
      if (sd.length) {
        var dRef = pct(sd, 0.9), cr = new Uint8Array(n); for (i = 0; i < n; i++) cr[i] = (mask[i] && diff[i] >= dRef * 0.28) ? 1 : 0;
        var cd = dil(cr, W, H, 2); for (i = 0; i < n; i++) if (mask[i] && !cd[i]) mask[i] = 0;
      }
      /* isolated speckles (fabric flecks, JPEG dust) never belong to a motif: fewer than 6 strong pixels in the 7x7 window -> gone (lines, dots and tips have more) */
      var mf = new Float32Array(n); for (i = 0; i < n; i++) mf[i] = mask[i];
      var mc = blur(mf, W, H, 3); for (i = 0; i < n; i++) if (mask[i] && mc[i] * 49 < 6) mask[i] = 0;
      /* strong pixels -> elements of the motif (dilated 4 px so that letters / limbs stay together) */
      var D = dil(mask, W, H, 4), lb = label(D, mask, W, H), L = lb.L, cnt = lb.cnt, bb = lb.bb, k;
      var ex0 = X.ex0, ex1 = X.ex1, ey0 = X.ey0, ey1 = X.ey1;
      var ok = new Uint8Array(L + 1), main = 0, mk = 0, HL = H * 0.31, WL = W * (knit ? 0.6 : 0.82);
      for (k = 1; k <= L; k++) {   /* elements touching the border of the analysed area are photo background / cap edge; elements larger than any motif are seams / washed fabric */
        var b0 = bb[k]; if (!b0 || b0[2] < 0) continue;
        if (b0[0] <= ex0 + 2 || b0[2] >= ex1 - 2 || b0[1] <= ey0 + 2 || b0[3] >= ey1 - 2) continue;
        if (b0[3] - b0[1] > HL || b0[2] - b0[0] > WL) continue;
        var dx0 = ((b0[0] + b0[2]) / 2 - W / 2) / (0.17 * W), dy0 = ((b0[1] + b0[3]) / 2 - H / 2) / (0.17 * H), sc = Math.sqrt(cnt[k]) * (0.05 + 0.95 * Math.exp(-(dx0 * dx0 + dy0 * dy0) / 2));
        ok[k] = 1; if (sc > main) { main = sc; mk = k; }   /* the motif sits near the middle of the frame (the crop is centred on it) */
      }
      if (!mk || cnt[mk] < 40) return EMPTY('none');
      var keep = new Uint8Array(L + 1), M0 = bb[mk], mg = Math.max(40, 0.6 * Math.max(M0[2] - M0[0], M0[3] - M0[1]));
      keep[mk] = 1;
      var coreD = []; for (i = 0; i < n; i++) if (lb.lab[i] === mk && mask[i]) coreD.push(diff[i]);
      var dMain = pct(coreD, 0.75);
      /* further pieces (letters, antenna tips, dots) must sit close to the main element, be as bright as thread, and the whole motif must stay motif-sized */
      var pd = []; for (k = 1; k <= L; k++) pd[k] = [];
      for (i = 0; i < n; i++) if (mask[i] && lb.lab[i] && lb.lab[i] !== mk) pd[lb.lab[i]].push(diff[i]);
      var cands = [];
      for (k = 1; k <= L; k++) {
        if (k === mk || !ok[k] || cnt[k] < 4) continue;
        var bh_ = bb[k][3] - bb[k][1] + 1, bw_ = bb[k][2] - bb[k][0] + 1;
        if (bh_ >= 50 && bh_ / bw_ >= 5) continue;   /* long upright strip = cap seam */
        var md = med(pd[k]);
        if (cnt[k] >= 25 ? md >= 0.3 * dMain : md >= 0.4 * dMain) cands.push(k);
      }
      var U = M0.slice(), Ub = M0.slice(), more = true;
      while (more && cands.length) {   /* nearest piece first; small pieces (dots, tips) are measured from the solid motif only, so a trail of specks cannot creep along a seam */
        more = false; var bi = -1, bg_ = 1e9;
        for (var ci = 0; ci < cands.length; ci++) {
          var kb = bb[cands[ci]], gx = Math.max(0, Ub[0] - kb[2], kb[0] - Ub[2]), gy = Math.max(0, Ub[1] - kb[3], kb[1] - Ub[3]), gp = Math.max(gx, gy);
          if (gp < bg_) { bg_ = gp; bi = ci; }
        }
        var kk = cands[bi], kb2 = bb[kk], big = cnt[kk] >= 80, lim = big ? Math.max(40, 0.5 * Math.max(Ub[2] - Ub[0], Ub[3] - Ub[1])) : cnt[kk] >= 25 ? 24 : 14;
        cands.splice(bi, 1); more = true;
        if (bg_ > lim) continue;
        var nu = [Math.min(U[0], kb2[0]), Math.min(U[1], kb2[1]), Math.max(U[2], kb2[2]), Math.max(U[3], kb2[3])];
        if (nu[3] - nu[1] <= HL && nu[2] - nu[0] <= WL) { keep[kk] = 1; U = nu; if (big) Ub = [Math.min(Ub[0], kb2[0]), Math.min(Ub[1], kb2[1]), Math.max(Ub[2], kb2[2]), Math.max(Ub[3], kb2[3])]; }
      }
      var nkeep = 0; for (k = 1; k <= L; k++) if (keep[k]) nkeep++;
      if (nkeep > 14) return EMPTY('noisy');   /* many tiny pieces = stitching / pattern of the fabric, not a motif */
      var kd = new Float32Array(n); for (i = 0; i < n; i++) kd[i] = (mask[i] && lb.lab[i] && keep[lb.lab[i]]) ? 1 : 0;
      var kdb = blur(kd, W, H, 6);   /* sparse dust left in the kept pieces (specks along a seam) has too few neighbours: strokes, dots and tips are dense enough */
      var K = new Uint8Array(n), tot = 0, tmin = H, tmax = 0, smin = W, smax = 0, core = [];
      for (i = 0; i < n; i++) if (kd[i] && kdb[i] * 169 >= 18) {
        K[i] = 1; tot++; core.push(diff[i]); y = (i / W) | 0; x = i % W;
        if (y < tmin) tmin = y; if (y > tmax) tmax = y; if (x < smin) smin = x; if (x > smax) smax = x;
      }
      /* vertical groups: rows of the motif are continuous; a thin trail of seam stitches above / below is separated by empty rows and far lighter than the motif -> dropped */
      var rc = new Int32Array(H), rpk = 0;
      for (i = 0; i < n; i++) if (K[i]) rc[(i / W) | 0]++;
      for (y = 0; y < H; y++) if (rc[y] > rpk) rpk = rc[y];
      var grp = [], gs = -1, gm = 0, blank = 0, lastRow = -1, gthr = Math.max(1, rpk * 0.04);
      for (y = 0; y < H; y++) {
        if (rc[y] > gthr) { if (gs < 0) { gs = y; gm = 0; } gm += rc[y]; lastRow = y; blank = 0; }
        else { blank++; if (gs >= 0 && blank >= 8) { grp.push([gs, lastRow, gm]); gs = -1; } }
      }
      if (gs >= 0) grp.push([gs, lastRow, gm]);
      if (grp.length > 1) {
        var gmax = 0; grp.forEach(function (g) { if (g[2] > gmax) gmax = g[2]; });
        grp.forEach(function (g) { if (g[2] < gmax * 0.25) for (var yy = g[0]; yy <= g[1]; yy++) for (var xx = 0; xx < W; xx++) if (K[yy * W + xx]) { K[yy * W + xx] = 0; tot--; } });
        tmin = H; tmax = 0; smin = W; smax = 0; core = [];
        for (i = 0; i < n; i++) if (K[i]) { core.push(diff[i]); y = (i / W) | 0; x = i % W; if (y < tmin) tmin = y; if (y > tmax) tmax = y; if (x < smin) smin = x; if (x > smax) smax = x; }
      }
      var st = { pol: pol, medF: medF, medS: medS, thr: thr, peak: peak, tot: tot, comps: L, bb: [smin, tmin, smax, tmax] };
      if (tot < 80) return EMPTY('small', st);
      var ccx = (smin + smax) / 2, ccy = (tmin + tmax) / 2;
      if (ccx < W * 0.2 || ccx > W * 0.8 || ccy < H * 0.2 || ccy > H * 0.8) return EMPTY('offcenter', st);
      if ((smax - smin + 1) / (tmax - tmin + 2) > 18) return EMPTY('line', st);   /* a single long thin line = seam / brim stitching, not a motif */
      var medCore = med(core); st.medCore = medCore;
      if (medCore < 40) return EMPTY('lowcontrast', st);
      if ((tmax - tmin) > H * 0.31 || (smax - smin) > W * (knit ? 0.6 : 0.82) || tot > 32768) return EMPTY('large', st);
      /* sanity of the polarity: dark thread must really be dark (shaded edges of white thread on a white cap are not), light thread must be clearly lighter than the cloth */
      var ys_ = []; for (i = 0; i < n; i++) if (K[i]) ys_.push(0.299 * px[i * 4] + 0.587 * px[i * 4 + 1] + 0.114 * px[i * 4 + 2]);
      var yK = med(ys_); st.yK = yK;
      if (pol === 'd' && yK > 115) return EMPTY('lowcontrast', st);
      var dCore = pct(core, 0.75), dLo = Math.max(8, thr * 0.3, dCore * 0.18), dHi = Math.max(dLo + 12, dCore * 0.6);
      /* coverage (soft matte): only close to the kept strong pixels (so that seams / flecks further away are never touched) */
      var reach = dil(K, W, H, 2), idx = [], cov = [], a, v;
      for (i = 0; i < n; i++) {
        if (!reach[i] || !inner[i]) continue;
        v = (diff[i] - dLo) / (dHi - dLo); if (v <= 0.02) continue; a = v > 1 ? 1 : Math.pow(v, 0.85); idx.push(i); cov.push(a);
      }
      /* fabric colour under / around the thread (for unmixing the anti-aliased edge) + shading of the thread */
      var dK = dil(K, W, H, 5), rx0 = Math.max(0, smin - 40), ry0 = Math.max(0, tmin - 40), rx1 = Math.min(W - 1, smax + 40), ry1 = Math.min(H - 1, tmax + 40), rw = rx1 - rx0 + 1, rh = ry1 - ry0 + 1, rn = rw * rh;
      var wg2 = new Float32Array(rn), ch = new Float32Array(rn), m = idx.length, fb = new Uint8Array(m * 3), c, fbA, fbB, xx, yy;
      for (yy = 0; yy < rh; yy++) for (xx = 0; xx < rw; xx++) wg2[yy * rw + xx] = dK[(yy + ry0) * W + xx + rx0] ? 0 : 1;
      for (c = 0; c < 3; c++) {
        for (yy = 0; yy < rh; yy++) for (xx = 0; xx < rw; xx++) ch[yy * rw + xx] = px[((yy + ry0) * W + xx + rx0) * 4 + c];
        fbA = nblur(ch, wg2, rw, rh, 10); fbB = nblur(ch, wg2, rw, rh, 30);
        for (var j = 0; j < m; j++) { var q = idx[j], rq = ((q / W | 0) - ry0) * rw + (q % W) - rx0; fb[j * 3 + c] = Math.max(0, Math.min(255, Math.round(fbA[rq] >= 0 ? fbA[rq] : fbB[rq] >= 0 ? fbB[rq] : px[q * 4 + c]))); }
      }
      /* chroma check of the soft (non-strong) pixels: on a coloured fabric, light flecks of the fabric have the saturation of the fabric,
         an anti-aliased thread edge lies between thread and fabric -> coverage by chroma (strong pixels are kept as they are) */
      var sk = []; for (i = 0; i < n; i++) if (K[i]) sk.push(Sat[i]); var sT = med(sk), idx2 = [], cov2 = [], fb2 = [], Sf, ac, g, mx_, mn_, jj;
      for (jj = 0; jj < idx.length; jj++) {
        var qq = idx[jj], cvj = cov[jj];
        if (!K[qq]) {
          mx_ = Math.max(fb[jj * 3], fb[jj * 3 + 1], fb[jj * 3 + 2]); mn_ = Math.min(fb[jj * 3], fb[jj * 3 + 1], fb[jj * 3 + 2]); Sf = 100 * (mx_ - mn_) / (mx_ + 8);
          if (pol === 'l' && Sf - sT >= 6) { ac = (Sf - Sat[qq]) / (Sf - sT); g = (ac - 0.1) / 0.4; g = g < 0 ? 0 : g > 1 ? 1 : g; cvj *= g; }
        }
        if (cvj <= 0.02) continue; idx2.push(qq); cov2.push(cvj); fb2.push(fb[jj * 3], fb[jj * 3 + 1], fb[jj * 3 + 2]);
      }
      idx = idx2; cov = cov2; fb = Uint8Array.from(fb2); m = idx.length;
      var ref = 110, hs = []; for (i = 0; i < n; i++) if (K[i]) hs.push(F[i]); ref = Math.max(110, pct(hs, 0.9));
      var tv = new Float32Array(m), ct = [], mnx = W, mny = H, mxx = -1, mxy = -1, rs = [0, 0, 0], rc = 0;
      for (var j2 = 0; j2 < m; j2++) {
        var q2 = idx[j2], t = pol === 'l' ? Math.min(1, F[q2] / ref) : (0.299 * px[q2 * 4] + 0.587 * px[q2 * 4 + 1] + 0.114 * px[q2 * 4 + 2]) / 255;
        tv[j2] = t; x = q2 % W; y = (q2 / W) | 0;
        if (cov[j2] > 0.8) ct.push(t);
        if (cov[j2] > 0.3) { if (x < mnx) mnx = x; if (x > mxx) mxx = x; if (y < mny) mny = y; if (y > mxy) mxy = y; }
      }
      st.ref = ref; st.dCore = dCore;
      return { ok: true, reason: 'ok', pol: pol, idx: Int32Array.from(idx), a: Float32Array.from(cov), t: tv, fab: fb, tmed: med(ct), bbox: [mnx, mny, mxx, mxy], st: st, score: medCore };
    }

    function motifScore(r, W, H) {
      if (!r.ok) return 0;
      var b = r.st.bb, cx = (b[0] + b[2]) / 2 - W / 2, cy = (b[1] + b[3]) / 2 - H / 2;
      return r.score * Math.sqrt(r.st.tot) * Math.exp(-(cx * cx / (0.3 * W * 0.3 * W) + cy * cy / (0.3 * H * 0.3 * H)) / 2);
    }
    function analyse(px, W, H, knit) {
      var n = W * H, i, x, y, F = { l: new Float32Array(n), d: new Float32Array(n) }, Sat = new Float32Array(n), inner = new Uint8Array(n), Yv = [];
      for (i = 0; i < n; i++) {
        var r = px[i * 4], g = px[i * 4 + 1], b = px[i * 4 + 2], mx = Math.max(r, g, b), mn = Math.min(r, g, b), s = mx - mn;
        Sat[i] = 100 * s / (mx + 8); F.l[i] = Math.max(0, mn - s); F.d[i] = Math.max(0, 255 - mx - s);
      }
      var X = { F: F, Sat: Sat, inner: inner, ex0: (W * 0.05) | 0, ex1: (W * 0.95) | 0, ey0: (H * 0.05) | 0, ey1: (H * 0.95) | 0 };
      for (y = X.ey0; y < X.ey1; y++) for (x = X.ex0; x < X.ex1; x++) inner[y * W + x] = 1;
      for (y = (H * 0.25) | 0; y < H * 0.75; y += 2) for (x = (W * 0.25) | 0; x < W * 0.75; x += 2) { var q = (y * W + x) * 4; Yv.push(0.299 * px[q] + 0.587 * px[q + 1] + 0.114 * px[q + 2]); }
      var fabY = med(Yv), order = fabY >= 150 ? ['d', 'l'] : ['l', 'd'], res = null, res2 = null, why = [];
      if (fabY < 200) {
        /* photo backdrop: pure-white area connected to the border of the frame (studio cut-outs) is not cap and never embroidery */
        var bgm = new Uint8Array(n), stk = new Int32Array(n), sp = 0, nbq;
        function seed(q) { if (!bgm[q] && Math.min(px[q * 4], px[q * 4 + 1], px[q * 4 + 2]) >= 232) { bgm[q] = 1; stk[sp++] = q; } }
        for (x = 0; x < W; x++) { seed(x); seed((H - 1) * W + x); }
        for (y = 0; y < H; y++) { seed(y * W); seed(y * W + W - 1); }
        while (sp) {
          var qb = stk[--sp], xb = qb % W, yb = (qb / W) | 0;
          if (xb > 0) seed(qb - 1); if (xb < W - 1) seed(qb + 1); if (yb > 0) seed(qb - W); if (yb < H - 1) seed(qb + W);
        }
        var bgd = dil(bgm, W, H, 6); for (i = 0; i < n; i++) if (bgd[i]) inner[i] = 0;
      }
      res = detect(px, W, H, knit, order[0], X);
      /* mid-light fabrics (lavender, beige, grey, light blue): thread may be lighter or darker than the cloth -> both readings compete, the more motif-like one wins */
      if (!res.ok || (fabY > 110 && fabY < 225)) {
        res2 = detect(px, W, H, knit, order[1], X);
        if (res2.ok && (!res.ok || motifScore(res2, W, H) > motifScore(res, W, H))) res = res2;
        else if (!res.ok) why.push([res2.reason, res2.st]);
      }
      if (!res.ok) return EMPTY(res.reason, { fabY: fabY, why: why, st: res.st });
      res.fabY = fabY; return res;
    }
    return { analyse: analyse };
  }

  /* ================= worker plumbing (falls back to the main thread when Workers / blob: are unavailable) ================= */
  var wk = null, wkFail = false, wkJobs = {}, wkSeq = 0, inlineCore = null;
  function getWorker() {
    if (wk || wkFail) return wk;
    try {
      var src = '(' + RDCORE.toString() + ')();';
      src = 'var core=(' + RDCORE.toString() + ')();self.onmessage=function(e){var d=e.data,r;try{r=core.analyse(new Uint8ClampedArray(d.buf),d.w,d.h,d.knit);}catch(x){r={ok:false,reason:"err:"+(x&&x.message)};}' +
        'var tr=[];if(r.idx){tr=[r.idx.buffer,r.a.buffer,r.t.buffer,r.fab.buffer];}self.postMessage({id:d.id,r:r},tr);};';
      wk = new Worker(URL.createObjectURL(new Blob([src], { type: 'application/javascript' })));
      wk.onmessage = function (e) { var j = wkJobs[e.data.id]; if (j) { delete wkJobs[e.data.id]; j(e.data.r); } };
      wk.onerror = function () { wkFail = true; var js = wkJobs; wkJobs = {}; try { wk.terminate(); } catch (x) { } wk = null; Object.keys(js).forEach(function (k) { js[k](null); }); };
    } catch (e) { wkFail = true; wk = null; }
    return wk;
  }
  function runCore(px, w, h, knit) {
    return new Promise(function (res) {
      var w1 = getWorker();
      function inline() { try { inlineCore = inlineCore || RDCORE(); res(inlineCore.analyse(px, w, h, knit)); } catch (e) { res({ ok: false, reason: 'err:' + (e && e.message) }); } }
      if (!w1) return inline();
      var id = ++wkSeq, copy = new Uint8ClampedArray(px);   /* px stays on the main thread (the base canvas is already drawn) */
      wkJobs[id] = function (r) { if (r) res(r); else inline(); };
      try { w1.postMessage({ id: id, buf: copy.buffer, w: w, h: h, knit: knit }, [copy.buffer]); } catch (e) { delete wkJobs[id]; inline(); }
    });
  }

  /* ================= image + entry cache ================= */
  var imgs = {}, cache = {}, inflight = {}, order = [];
  function hexRgb(h) {
    h = String(h || '').trim().replace('#', '');
    if (h.length === 3) h = h.replace(/(.)/g, '$1$1');
    var n = parseInt(h, 16); if (isNaN(n)) return [255, 255, 255];
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function isWhiteHex(h) { return /^#?(fff|ffffff)$/i.test(String(h || '').trim()); }
  /* a properly sized photo (~800 px wide is plenty for a 640 px analysis frame); other hosts are left alone */
  function nurl(u) {
    u = String(u || ''); if (u.indexOf('//') === 0) u = 'https:' + u;
    if (/\/cdn\/shop\//.test(u)) u = /([?&])width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=800') : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=800';
    return u;
  }
  function loadImg(u) {
    if (imgs[u]) return imgs[u];
    return (imgs[u] = new Promise(function (res, rej) {
      var im = new Image(); im.crossOrigin = 'anonymous'; im.decoding = 'async';
      im.onload = function () { res(im); }; im.onerror = function () { delete imgs[u]; rej(new Error('img')); }; im.src = u;
    }));
  }
  function ckey(u, crop) { return u + (crop ? '|' + crop.x + ',' + crop.y + ',' + crop.w : ''); }
  function build(u, crop) {
    return loadImg(u).then(function (im) {
      crop = crop || DEF_CROP;
      var iw = im.naturalWidth, ih = im.naturalHeight, cw = Math.min(iw, iw * crop.w), rh = Math.min(ih, cw), fh = Math.round(FW * rh / cw);
      var sx = Math.max(0, Math.min(iw - cw, iw * crop.x - cw / 2)), sy = Math.max(0, Math.min(ih - rh, ih * crop.y - rh / 2));
      var base = document.createElement('canvas'); base.width = FW; base.height = fh;
      var bx = base.getContext('2d', { willReadFrequently: true });
      bx.drawImage(im, sx, sy, cw, rh, 0, 0, FW, fh);
      var id = bx.getImageData(0, 0, FW, fh), knit = crop.w < 0.7, t0 = performance.now();
      return runCore(id.data, FW, fh, knit).then(function (r) {
        var e = { u: u, base: base, W: FW, H: fh, reason: r.reason, ok: !!r.ok, ms: performance.now() - t0, st: r.st || null, pol: r.pol };
        if (r.ok) {
          e.idx = r.idx; e.a = r.a; e.t = r.t; e.fab = r.fab; e.tmed = r.tmed; e.pol = r.pol; e.fabY = r.fabY; e.bbox = r.bbox;
          /* the patch: original pixels of the bounding area of the mask, tinted copy goes into patchCv (alpha only on the mask) */
          var bb = r.bbox, pad = 2, x0 = Math.max(0, bb[0] - pad), y0 = Math.max(0, bb[1] - pad), x1 = Math.min(FW - 1, bb[2] + pad), y1 = Math.min(fh - 1, bb[3] + pad);
          var pm = [FW, fh, -1, -1], k, q, xx, yy;
          for (k = 0; k < e.idx.length; k++) { q = e.idx[k]; xx = q % FW; yy = (q / FW) | 0; if (xx < pm[0]) pm[0] = xx; if (xx > pm[2]) pm[2] = xx; if (yy < pm[1]) pm[1] = yy; if (yy > pm[3]) pm[3] = yy; }
          e.px = [Math.max(0, pm[0] - 1), Math.max(0, pm[1] - 1)]; e.pw = Math.min(FW, pm[2] + 2) - e.px[0]; e.ph = Math.min(fh, pm[3] + 2) - e.px[1];
          e.patch = document.createElement('canvas'); e.patch.width = e.pw; e.patch.height = e.ph; e.pctx = e.patch.getContext('2d');
          e.pimg = e.pctx.createImageData(e.pw, e.ph);
          /* crop: bounding box of the embroidery + 15 % padding, 2:1, never cut, not zoomed in too much */
          var bw = bb[2] - bb[0] + 1, bh = bb[3] - bb[1] + 1, cx = (bb[0] + bb[2] + 1) / 2, cy = (bb[1] + bb[3] + 1) / 2;
          var rw = Math.max(bw * 1.3, bh * 1.3 * 2, 300); rw = Math.min(rw, FW, fh * 2);
          var rhh = rw / 2, rx = Math.max(0, Math.min(FW - rw, cx - rw / 2)), ry = Math.max(0, Math.min(fh - rhh, cy - rhh / 2));
          e.crop = [rx, ry, rw, rhh];
        } else {
          e.idx = new Int32Array(0); e.crop = [0, Math.max(0, fh / 2 - OH / 2), FW, Math.min(OH, fh)];   /* the original band as before */
        }
        return e;
      });
    });
  }
  function load(url, crop) {
    var u = nurl(url), key = ckey(u, crop);
    if (cache[key]) return Promise.resolve(cache[key]);
    if (inflight[key]) return inflight[key];
    return (inflight[key] = build(u, crop).then(function (e) {
      delete inflight[key]; cache[key] = e; order.push(key);
      while (order.length > MAXC) { delete cache[order.shift()]; }
      return e;
    }, function (err) { delete inflight[key]; throw err; }));
  }
  function peek(url, crop) { return cache[ckey(nurl(url), crop)] || null; }

  /* ================= tint: only the cached mask is re-coloured ================= */
  function tint(e, rgb) {
    var d = e.pimg.data, n = e.idx.length, j, q, p, x, y, a, sh, c, v, fr, fg, fb, R = rgb[0], G = rgb[1], B = rgb[2], W = e.W, ox = e.px[0], oy = e.px[1], pw = e.pw, tm = e.tmed, t, dk = e.pol === 'd'; var lt = (0.299 * R + 0.587 * G + 0.114 * B) / 255, lo = Math.min(0.97, 0.55 + 0.42 * lt), amp = 0.8 * Math.max(0.2, 1 - 1.6 * Math.max(0, lt - 0.5));
    d.fill(0);
    for (j = 0; j < n; j++) {
      q = e.idx[j]; x = (q % W) - ox; y = ((q / W) | 0) - oy; if (x < 0 || y < 0 || x >= pw || y >= e.ph) continue;
      a = e.a[j]; t = e.t[j]; p = (y * pw + x) * 4; fr = e.fab[j * 3]; fg = e.fab[j * 3 + 1]; fb = e.fab[j * 3 + 2];
      if (dk) { sh = (t - tm) * 255 * amp * a; c = [R + sh, G + sh, B + sh]; }   /* světlá nit (bílá): stín slabší, aby nešedla */
      else { sh = 1 + (Math.max(lo, Math.min(1.12, 1 + 0.8 * (t - tm))) - 1) * a; c = [R * sh, G * sh, B * sh]; }
      v = a * c[0] + (1 - a) * fr; d[p] = v < 0 ? 0 : v > 255 ? 255 : v;
      v = a * c[1] + (1 - a) * fg; d[p + 1] = v < 0 ? 0 : v > 255 ? 255 : v;
      v = a * c[2] + (1 - a) * fb; d[p + 2] = v < 0 ? 0 : v > 255 ? 255 : v;
      d[p + 3] = 255;
    }
    e.pctx.putImageData(e.pimg, 0, 0);
  }
  function paintEntry(cv, e, hex) {
    if (cv.width !== OW || cv.height !== OH) { cv.width = OW; cv.height = OH; }
    var ctx = cv.getContext('2d'), c = e.crop, k = OW / c[2];
    ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(e.base, c[0], c[1], c[2], c[3], 0, 0, OW, OH);
    if (e.ok) {   /* bílá nit se přebarvuje také (dřív se nechala původní fotka, kde je nit našedlá) */
      tint(e, hexRgb(hex));
      ctx.drawImage(e.patch, (e.px[0] - c[0]) * k, (e.px[1] - c[1]) * k, e.pw * k, e.ph * k);
    }
  }

  window.RdThread = {
    _load: load, _hex: hexRgb,
    mount: function (cv, url, hex, crop) {
      return load(url, crop).then(function (e) { paintEntry(cv, e, hex); return { ok: e.ok, reason: e.reason }; });
    },
    /* synchronous repaint from cache (colour change): returns null when the photo has not been analysed yet */
    paintSync: function (cv, url, hex, crop) {
      var e = peek(url, crop); if (!e) return null; paintEntry(cv, e, hex); return { ok: e.ok, reason: e.reason };
    },
    prefetch: function (url, crop) { return load(url, crop).catch(function () { return null; }); },
    /* recoloured patch for compositing onto the full photo (set editor): { canvas, x, y, w, h } as fractions of the photo */
    overlay: function (url, hex, crop) {
      return load(url, crop).then(function (e) {
        if (!e.ok) return { ok: e.ok, reason: e.reason, canvas: null };
        tint(e, hexRgb(hex));
        var u = nurl(url), cr = crop || DEF_CROP;
        return loadImg(u).then(function (im) {
          var iw = im.naturalWidth, ih = im.naturalHeight, cw = Math.min(iw, iw * cr.w), rh = Math.min(ih, cw), sx = Math.max(0, Math.min(iw - cw, iw * cr.x - cw / 2)), sy = Math.max(0, Math.min(ih - rh, ih * cr.y - rh / 2)), k = cw / FW;
          return { ok: true, reason: 'ok', canvas: e.patch, fx: (sx + e.px[0] * k) / iw, fy: (sy + e.px[1] * k) / ih, fw: e.pw * k / iw, fh: e.ph * k / ih };
        });
      });
    },
    _info: function (url, crop) { var e = peek(url, crop); return e && { ok: e.ok, reason: e.reason, ms: e.ms, pol: e.pol, crop: e.crop, st: e.st, n: e.idx.length }; },
    _nurl: nurl
  };

  function parseCrop(v) {
    var a = String(v || '').split(',').map(parseFloat);
    return a.length === 3 && a.every(function (x) { return x > 0; }) ? { x: a[0], y: a[1], w: a[2] } : null;
  }
  /* ---------- "Your design" cards in the cart / drawer / toast ---------- */
  function scan(rootEl) {
    var list = (rootEl || document).querySelectorAll('canvas[data-rd-thread-cv]:not([data-rd-done])');
    list.forEach(function (cv) {
      cv.setAttribute('data-rd-done', '1');
      var fig = cv.closest('[data-rd-thread-fig]');
      window.RdThread.mount(cv, cv.getAttribute('data-src'), cv.getAttribute('data-hex'), parseCrop(cv.getAttribute('data-crop'))).then(function (res) {
        if (fig) { fig.classList.add('is-ready'); if (!res.ok && !isWhiteHex(cv.getAttribute('data-hex'))) { fig.classList.add('is-fallback'); fig.style.setProperty('--rd-fb', cv.getAttribute('data-hex')); } }
      }).catch(function () { cv.removeAttribute('data-rd-done'); });
    });
  }
  var t = null;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { scan(); }, 80); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', function () { scan(); });

  /* ---------- PDP tile (colour change) ---------- */
  /* The tile is attached after the DOM is built: the cart-card script (drawer / toast) can load earlier than the tile. */
  function initPdp() {
    var root = document.querySelector('[data-rd-preview]');
    if (!root) return;
    var cv = root.querySelector('[data-rd-pv-canvas]');
    var dotEl = root.querySelector('[data-rd-pv-dot]'), nameEl = root.querySelector('[data-rd-pv-name]');
    /* the theme re-renders the product block when the variant changes: nodes may be replaced, so always work with the current ones */
    function refresh() {
      var r2 = document.querySelector('[data-rd-preview]'); if (!r2 || r2 === root) return false;
      root = r2; cv = root.querySelector('[data-rd-pv-canvas]'); dotEl = root.querySelector('[data-rd-pv-dot]'); nameEl = root.querySelector('[data-rd-pv-name]'); lastSig = ''; window.RdThread.pdp.cv = cv; return true;
    }
    var data = {}; try { data = JSON.parse(root.querySelector('[data-rd-pv-data]').textContent); } catch (e) { return; }
    var token = 0, crop = parseCrop(data.crop);
    function selected() {
      var b = document.querySelector('[data-capkov-colors] .capkov-b2__color[data-active="true"]');
      if (!b) return { name: data.white, hex: '#ffffff' };
      var dot = b.querySelector('.capkov-b2__dot'), hex = dot ? dot.style.getPropertyValue('--capkov-dot') : '#fff';
      return { name: b.getAttribute('data-color'), hex: hex.trim() || '#fff' };
    }
    function variantImg() {
      var vid = '', f = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (f && f.value) vid = f.value;
      var m = /[?&]variant=(\d+)/.exec(location.search); if (m) vid = m[1];
      var v = data.variants.filter(function (x) { return String(x.id) === String(vid); })[0] || data.variants[0];
      return { key: v ? String(v.id) : 'x', url: nurl((v && v.img) || data.fallback) };
    }
    /* the previous render stays on screen while a new photo is analysed (the box is never blank); a cached photo is re-tinted synchronously */
    var lastSig = '', lastP = Promise.resolve(), lastInfo = null, painted = false, busyT = 0;
    function finish(res, c, my) {
      if (my !== token) return;
      var fb = !res.ok && !isWhiteHex(c.hex);   /* the mask could not find the thread reliably: original photo + colour chip */
      root.classList.toggle('is-fallback', fb);
      var chip = root.querySelector('[data-rd-pv-chip]'), fbn = root.querySelector('[data-rd-pv-fb]'), nn = root.querySelector('[data-rd-pv-note]');
      if (chip) { chip.hidden = !fb; chip.style.background = c.hex; }
      if (fbn) fbn.hidden = !fb; if (nn) nn.hidden = fb;
      dotEl.style.background = c.hex; nameEl.textContent = c.name;
      clearTimeout(busyT); root.hidden = false; root.classList.remove('is-busy'); root.classList.remove('is-ph'); painted = true;
      lastInfo = { ok: res.ok, fallback: fb, hex: c.hex, name: c.name, white: isWhiteHex(c.hex) };
    }
    function render() {
      refresh();
      var vi = variantImg(), c = selected(), sig = vi.url + '|' + c.hex + '|' + c.name;
      if (sig === lastSig) return lastP; lastSig = sig;
      var my = ++token; root.setAttribute('data-rd-pv-src', vi.url); root.setAttribute('data-rd-pv-var', vi.key);
      /* cached photo: re-tint synchronously (a few ms), no busy state, no flash */
      var sync = window.RdThread.paintSync(cv, vi.url, c.hex, crop);
      if (sync) { finish(sync, c, my); return (lastP = Promise.resolve()); }
      /* not analysed yet: keep what is on screen, show the veil only when it takes noticeable time */
      clearTimeout(busyT); busyT = setTimeout(function () { if (my === token) root.classList.add('is-busy'); }, 160);
      return (lastP = window.RdThread.mount(cv, vi.url, c.hex, crop).then(function (res) { finish(res, c, my); }).catch(function (e) {
        clearTimeout(busyT); root.classList.remove('is-busy'); if (!painted) root.hidden = true; lastInfo = null; try { console.info('rd-preview:', e && e.message || e); } catch (_) { }
      }));
    }
    /* order preview (capkov-rd-nahled.js): the finished canvas with the recoloured embroidery (same output as the tile on the PDP) */
    window.RdThread.pdp = { cv: cv, snapshot: function () { return render().then(function () { return lastInfo && !root.hidden ? { canvas: cv, info: lastInfo } : null; }); } };
    var started = false;
    function warmOthers() {   /* after the panel is open: analyse the photos of the other cap colours in idle time, so switching is instant */
      if (navigator.connection && navigator.connection.saveData) return;
      var list = data.variants.map(function (v) { return nurl(v.img); }).filter(function (u, i, a) { return u && a.indexOf(u) === i && !peek(u, crop); }).slice(0, 7), i = 0;
      (function next() { if (i >= list.length) return; var u = list[i++]; window.RdThread.prefetch(u, crop).then(function () { setTimeout(next, 250); }); })();
    }
    function start() {
      if (started) return; started = true;
      render();
      try { new MutationObserver(render).observe(document.querySelector('[data-capkov-cc]'), { subtree: true, attributes: true, attributeFilter: ['data-active'], childList: true }); } catch (e) { }
      document.addEventListener('click', function () { setTimeout(render, 30); }, true);
      document.addEventListener('variant:change', function () { setTimeout(render, 60); });
      setInterval(render, 700);
      setTimeout(warmOthers, 1200);
    }
    var cc = document.querySelector('[data-capkov-cc]');
    if (!cc) return;
    var idle = function (f) { if (window.requestIdleCallback) window.requestIdleCallback(f, { timeout: 1500 }); else setTimeout(f, 800); };
    /* prefetch: photo + analysis of the current variant right after load (idle), long before the panel is opened */
    function warm() { window.RdThread.prefetch(variantImg().url, crop); }
    idle(warm);   /* does not wait for the load event: the photo + analysis are ready long before the panel is opened */
    /* user intent (hover / touch / focus on the toggle) = start immediately */
    ['pointerenter', 'touchstart', 'pointerdown', 'focusin'].forEach(function (ev) { var sm = cc.querySelector('summary'); if (sm) sm.addEventListener(ev, function () { warm(); }, { passive: true, once: true }); });
    if (cc.open) start(); else cc.addEventListener('toggle', function () { if (cc.open) start(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPdp); else initPdp();
})();
